export type ApiKeyModel = {
  cache_key: string,
  id: number,
  default_user_id?: number,
  enabled: boolean,
  owner_id?: number,
  owner_type?: string,
  title: string,
  token: string,
}

export type ApiKeyRequestOptions = {}

const state = {
  id: null,
  default_user_id: undefined,
  enabled: false,
  owner_id: undefined,
  owner_type: '',
  title: '',
  token: '',
}

export const requiredFields = [
  { key: 'default_user_id' },
]

export default state
